var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { getNoteName, isBlackKey } from '../utils/Notes';
var FontAwesome = require('../../templates/FontAwesome');
var moduleStyles = require('./chordPanel.module.scss').default;
var classNames = require('classnames');
var NUM_OCTAVES = 3;
var START_OCTAVE = 4;
var MAX_NOTES = 16;
var styleDropdownOptions = [
    ['arpeggio-up', 'Arpeggio Up'],
    ['arpeggio-down', 'Arpeggio Down'],
    ['arpeggio-random', 'Arpeggio Random'],
    ['together', 'Together']
];
var ChordPanel = function (_a) {
    var initValue = _a.initValue, onChange = _a.onChange, previewChord = _a.previewChord, library = _a.library;
    var _b = useState(initValue.notes), selectedNotes = _b[0], setSelectedNotes = _b[1];
    var _c = useState(initValue.playStyle), playStyle = _c[0], setPlayStyle = _c[1];
    var _d = useState(initValue.instrument), instrument = _d[0], setInstrument = _d[1];
    var _e = useState(false), isPlayingPreview = _e[0], setIsPlayingPreview = _e[1];
    var _f = useState(selectedNotes.length >= MAX_NOTES), isDisabled = _f[0], setIsDisabled = _f[1];
    var instruments = library.groups[0].folders
        .filter(function (folder) { return folder.type === 'instrument'; })
        .map(function (folder) { return [folder.name, folder.path]; });
    var onPressKey = function (note) {
        var newSelectedNotes = __spreadArray([], selectedNotes, true);
        if (newSelectedNotes.includes(note)) {
            newSelectedNotes.splice(newSelectedNotes.indexOf(note), 1);
        }
        else {
            newSelectedNotes.push(note);
        }
        setSelectedNotes(newSelectedNotes);
    };
    var previewTimeoutIdRef = useRef(null);
    var onPreview = function () {
        if (isPlayingPreview) {
            return;
        }
        setIsPlayingPreview(true);
        previewChord({
            notes: selectedNotes,
            playStyle: playStyle,
            instrument: instrument
        }, function () {
            setIsPlayingPreview(false);
            if (previewTimeoutIdRef.current !== null) {
                clearTimeout(previewTimeoutIdRef.current);
            }
        });
        // Set a timeout to reset the preview button in case there is an error
        // playing a preview.
        previewTimeoutIdRef.current = window.setTimeout(function () {
            if (previewTimeoutIdRef.current !== null) {
                console.warn("Preview timeout expired. Resetting preview buttton.");
                setIsPlayingPreview(false);
            }
            previewTimeoutIdRef.current = null;
        }, 5000);
    };
    useEffect(function () {
        onChange({
            notes: selectedNotes,
            playStyle: playStyle,
            instrument: instrument
        });
    }, [instrument, playStyle, selectedNotes]);
    useEffect(function () {
        setIsDisabled(selectedNotes.length >= MAX_NOTES);
    }, [selectedNotes]);
    return (React.createElement("div", { className: moduleStyles.chordPanelContainer },
        React.createElement("div", { className: moduleStyles.controlsRow },
            React.createElement("select", { value: instrument, onChange: function (event) { return setInstrument(event.target.value); }, className: moduleStyles.dropdown }, instruments.map(function (_a) {
                var name = _a[0], value = _a[1];
                return (React.createElement("option", { key: value, value: value }, name));
            })),
            React.createElement("select", { value: playStyle, onChange: function (event) { return setPlayStyle(event.target.value); }, className: moduleStyles.dropdown }, styleDropdownOptions.map(function (_a) {
                var playStyle = _a[0], label = _a[1];
                return (React.createElement("option", { key: playStyle, value: playStyle }, label));
            }))),
        React.createElement(Keybed, { numOctaves: NUM_OCTAVES, startOctave: START_OCTAVE, selectedNotes: selectedNotes, onPressKey: onPressKey, isDisabled: isDisabled }),
        React.createElement("div", { className: moduleStyles.controlsRow },
            React.createElement(FontAwesome, { icon: 'volume-up', onClick: onPreview, className: classNames(moduleStyles.previewButton, isPlayingPreview && moduleStyles.previewButtonDisabled) }),
            React.createElement(FontAwesome, { icon: 'ban', onClick: function () { return setSelectedNotes([]); }, className: moduleStyles.previewButton }))));
};
var Keybed = function (_a) {
    var numOctaves = _a.numOctaves, startOctave = _a.startOctave, selectedNotes = _a.selectedNotes, onPressKey = _a.onPressKey, isDisabled = _a.isDisabled;
    var keys = [];
    var startingNote = startOctave * 12;
    var _loop_1 = function (currentNote) {
        keys.push(React.createElement(Key, { key: currentNote, type: isBlackKey(currentNote) ? 'black' : 'white', isDisabled: isDisabled, isSelected: selectedNotes.includes(currentNote), onClick: function () { return onPressKey(currentNote); }, text: !isBlackKey(currentNote) ? getNoteName(currentNote) : undefined }));
    };
    for (var currentNote = startingNote; currentNote < startingNote + numOctaves * 12; currentNote++) {
        _loop_1(currentNote);
    }
    return React.createElement("div", { className: moduleStyles.keybed }, keys);
};
var Key = function (_a) {
    var type = _a.type, isSelected = _a.isSelected, isDisabled = _a.isDisabled, onClick = _a.onClick, text = _a.text;
    return (React.createElement("div", { className: classNames(moduleStyles.key, isDisabled && moduleStyles.disabled, isSelected && moduleStyles.selected, type === 'white' && moduleStyles.whiteKey, type === 'black' && moduleStyles.blackKey), onClick: onClick },
        React.createElement("p", { className: moduleStyles.noteLabel }, text)));
};
export default ChordPanel;
